import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import logo from '../../../Components/home/images/logo.png';
import loginImage from '../../../assets/images/couples/Vector.png';
import { Link } from "react-router-dom"
// import { FcGoogle } from "react-icons/fc";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { LoginContext } from "../../../context/LoginContext";
import { SignupContext } from "../../../context/SignupContext";

const LoginPage = () => {




    const [formData, setFormData] = useState({ username: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const navigate = useNavigate(); // Optional if you want to redirect

   const {userId, isLoggedIn, setUserName, setUserId, setUserdata, setIsLoggedIn } = useContext(LoginContext);
    const {
        setUserName: setSignupUsername,
        setAPIFormData,
        setUserId: setSignupUserId,
        setIsLoggedIn: setSignupIsloggedIn
    } = useContext(SignupContext);

  
    useEffect(() => {
  
      if (isLoggedIn) {
        navigate("/recently-joined-matches");
      }

    });


    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthdateDate = new Date(birthdate);

        let calculatedAge = today.getFullYear() - birthdateDate.getFullYear();
        const monthDiff = today.getMonth() - birthdateDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdateDate.getDate())) {
            calculatedAge--;
        }
        return (calculatedAge);
    };



    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const validateForm = () => {

        const newErrors = {};
        if (formData.username == "") newErrors.mobile = "Mobile Number is Required";
        else if (formData.username.length != 10) newErrors.mobile = "Mobile Number Should be 10 digit only";
        if (formData.password == "") newErrors.password = "Password is Required";
        else if (formData.password.length < 6) newErrors.password = "Password Should At least 6 Digit";

        setError(newErrors);

        return Object.keys(newErrors).length === 0;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError({});
        if (!validateForm()) return;

        try {

            const payload = new FormData();
            payload.append("email", formData.username);
            payload.append("password", formData.password);

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}login_controller/login`, payload);

            if (response.data.response == 'failed') {
                setError({ mobile: response.data.message.mobile, password: response.data.message.password });
            } else if (response.data.response == "invalid") {
                setError({ api: response.data.message });
            } else if (response.data.response == "redirect") {
                setLoading(true);
                setError({});
                let user = response?.data?.user;
                let ProfileBy = "Myself";
                if (user.pro_for == "Self") {
                    ProfileBy = "Myself";
                } else if (user.pro_for == "Son" || user.pro_for == "Daughter") {
                    ProfileBy = "My Parents";
                } else if (user.pro_for == "Brother") {
                    ProfileBy = "My Sister";
                } else if (user.pro_for == "Sister") {
                    ProfileBy = "My Brother";
                } else if (user.pro_for == "Friend") {
                    ProfileBy = "My Friend";
                }

                // user Information save in context api
                setAPIFormData({
                    email: (user.email),
                    age: (calculateAge(user.dob)),
                    height: (user.height),
                    profileFor: (ProfileBy),
                    language: (user.language),
                    family_type: (user.family_type),
                    highest_education: (user.highest_edu),
                    occupation: (user.occupation),
                    hobbies: user.hobbies.split(','),
                    country: user.country,
                    state: user.state
                });
                setSignupUsername(user.name);
                setSignupIsloggedIn(true);
                setSignupUserId(user.user_id);
                navigate(response.data.url);
            } else if (response.data.response == "approval") {
                setLoading(true);
                setError({});
                let user = response?.data?.user;
                // user Information save in context api
                setIsLoggedIn(true);
                setUserName(user.name);
                setUserId(user.id);
                setUserdata(user);
                navigate("/recently-joined-matches")
            } else if (response.data.response == "login") {
                setLoading(true);
                setError({});
                let user = response?.data?.user;
                // user Information save in context api
                setIsLoggedIn(true);
                setUserName(user.name);
                setUserId(user.id);
                setUserdata(user);
                navigate("/recently-joined-matches")

            }

            // else if (response.data.response == "success") {
            //   setLoading(true);
            //   setError({});
            //
            //      let user=response?.data?.user;
            //   // user Information save in context api
            //   setIsLoggedIn(true);
            //   setUserName(user.name);
            //   setUserId(user.id);
            //   setUserdata(user);
            //
            //
            //
            //   alert("Login successful!");
            //
            // }

            else {
                setError({ api: "Something went Wrong\nTry Again" });
            }


            // Example: Save token and redirect
            // localStorage.setItem("token", response.data.token);
            // navigate("/dashboard");

            // alert("Login successful!");
        } catch (err) {
            console.error('Login error:', err);
            setError({ api: 'Invalid username or password.' });
        } finally {
            setLoading(false);
        }
    };

    return (

        <>
            <div className='py-md-5'></div>


            <div className="page-container">
                <div className="login-container">
                    <div className="login-wrapper">
                        <div className="login-left">
                            <h2 className="login-title text-center fw-normal" >Welcome Back</h2>
                            {/* <p className="login-subtitle text-center">Login to your account</p> */}

                            {/* <button className="google-btn">
              <FcGoogle size={20} />
              Login with Google
            </button>

            <div className="divider"><span>Or</span></div> */}
                            {error.api &&
                                <div className='alert alert-danger mb-2 text-center'><strong> {error.api}</strong></div>}

                            <form className="login-form" onSubmit={handleSubmit}>
                                {error.mobile && <div className='alert alert-danger mb-0'>{error.mobile}</div>}
                                <div className="form-group">
                                    <label>Phone *</label>
                                    <input
                                        class="bgtnme"
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleChange}
                                        placeholder="Enter your Phone Number"
                                        required
                                    />
                                </div>
                                {error.password && <div className='alert alert-danger mb-0'>{error.password}</div>}

                                <div className="form-group">
                                    <label>Password *</label>

                                    <div class="input-group">
                                        <input type={showPassword ? 'text' : 'password'} value={formData.password}
                                            name='password' onChange={handleChange} class="form-control bgtnme"
                                            placeholder="Enter your password" aria-label="Enter your password"
                                            aria-describedby="basic-addon2" required />
                                        <span class="input-group-text" id="basic-addon2"
                                            onClick={() => (setShowPassword((prev) => !prev))}
                                            style={{ cursor: 'pointer' }}> {showPassword ? <FaEye size={22} /> :
                                                <FaEyeSlash size={22} />} </span>
                                    </div>

                                </div>

                                {/* {error && <div style={{ color: 'red', fontSize: '0.9rem' }}>{error}</div>} */}

                                <div className="form-footer">
                                    <label className="remember-me">
                                        <input type="checkbox" /> Remember me
                                    </label>
                                    <a href="fogot-password" className="forgot-password">Forgot Password?</a>
                                </div>

                                <button type="submit" className="login-btn" disabled={loading}>
                                    {loading ? 'Logging in...' : 'Login'}
                                </button>
                            </form>

                            <p className="create-account">
                                Don't have an account? <Link to={"/sign-up"}>Create Account</Link>
                            </p>
                        </div>

                        <div className="login-right d-none d-lg-block">
                            <img src={loginImage} alt="Couple" className="login-image" />
                            <div className="image-overlay">
                                <h2 className='text-light'>Your Journey To Love Begins <span
                                    className="highlight">Here</span></h2>
                                <p>Connect With Genuine Matches Who <br />
                                    Share Your <span className="highlight">Values</span> And <span
                                        className="highlight">Dreams</span>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <style jsx>{`
                /* Container Styles */

                .bgtnme{
                background:white !important;
                }




                .page-container {
                    width: 100%;
                    
                    display: flex;
                    justify-content: center;
                    background-color:#FFFFFF;
                    padding: 20px;
                }

                .login-container {
                    width: 100%;
                    max-width: 1200px;
                    background-color: white;
                    border-radius: 16px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
                    overflow: hidden;
                }

                /* Main layout */
                .login-wrapper {
                    display: flex;
                    height: 100%;
                    width: 100%;
                      align-items: start;
                    font-family: 'Segoe UI', sans-serif;
                }

                /* Left side (Form) */
                .login-left {
                    flex: 1;
                    padding: 60px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    background-color: #fff;
                }

                .login-logo {
                    width: 160px;
                    margin-bottom: 30px;
                }

                .login-title {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #222;
                    margin-bottom: 8px;
                }

                .login-subtitle {
                    color: #666;
                    margin-bottom: 30px;
                    font-size: 1rem;
                }

                .google-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: white;
                    border: 1px solid #ddd;
                    padding: 12px;
                    gap: 10px;
                    border-radius: 8px;
                    cursor: pointer;
                    font-weight: 500;
                    margin-bottom: 24px;
                    transition: all 0.2s ease;
                    font-size: 0.95rem;
                }

                .google-btn:hover {
                    background-color: #f9f9f9;
                    border-color: #ccc;
                }

                .divider {
                    display: flex;
                    align-items: center;
                    text-align: center;
                    margin: 20px 0;
                    color: #999;
                    font-size: 0.9rem;
                }

                .divider::before,
                .divider::after {
                    content: "";
                    flex: 1;
                    height: 1px;
                    background: #eee;
                }

                .divider span {
                    padding: 0 12px;
                }

                /* Form Styles */
                .login-form {
                    display: flex;
                    flex-direction: column;
                   
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    margin-bottom:5px;
                   
                }

                .form-group label {
                    font-size: 14px;
                    color: #444;
                    margin-bottom:0px;
                }

                .login-form input {
                    padding: 9.5px;
                    border-radius: 15px;
                    border: 1px solid #ddd;
                    font-size: 1rem;
                    transition: border 0.2s ease;
                }

                .login-form input:focus {
                    outline: none;
                    border-color: #e53d5c;
                    box-shadow: 0 0 0 2px rgba(229, 61, 92, 0.1);
                }

                .form-footer {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 0.9rem;
                    margin-top: 5px;
                }

                .remember-me {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    color: #666;
                }

                .forgot-password {
                    text-decoration: none;
                    color: #e53d5c;
                    font-weight: 500;
                    transition: color 0.2s ease;
                }

                .forgot-password:hover {
                    color: #c2314b;
                }

                .login-btn {
                    padding: 14px;
                    background-color: #e53d5c;
                    color: #fff;
                    border: none;
                    font-weight: 600;
                    border-radius: 8px;
                    cursor: pointer;
                    margin-top: 10px;
                    font-size: 1rem;
                    transition: background-color 0.2s ease;
                }

                .login-btn:hover {
                    background-color: #c2314b;
                }

                .create-account {
                    margin-top: 24px;
                    font-size: 0.95rem;
                    color: #666;
                    text-align: center;
                }

                .create-account a {
                    color: #e53d5c;
                    font-weight: 500;
                    text-decoration: none;
                    transition: color 0.2s ease;
                }

                .create-account a:hover {
                    color: #c2314b;
                    text-decoration: underline;
                }

                /* Right side (Image & Text) */
                .login-right {
                    flex: 1;
                    position: relative;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 500px;
                }

                .login-image {
                    width: 100%;
                    height: 100%;
                    object-fit: ;
                    object-position: center;
                    padding-right:;
                    border-radius: 15px;
                }

                .image-overlay {
                    position: absolute;
                    color: #333;
                    text-align: center;
                    padding: 20px;
                    max-width: 100%;
                    bottom: 40px;
                }

                .image-overlay h2 {
                    font-size: 1.8rem;
                    font-weight: 700;
                    line-height: 1.4;
                    margin-bottom: 12px;
                }

                .image-overlay p {
                    font-size: 1rem;
                    line-height: 1.6;
                    color:white;
                    font-weight:bold;
                }

                .highlight {
                    color:#ffc107;
                    font-weight: 600;
                }

                /* Responsive */
                @media (max-width: 1024px) {
                    .login-left {
                        padding: 40px;
                    }

                    .login-title {
                        font-size: 1.8rem;
                    }
                }

                @media (max-width: 768px) {
                    .login-wrapper {
                        flex-direction: column;
                    }

                    .login-right {
                        min-height: 300px;
                    }

                    .image-overlay h2 {
                        font-size: 1.5rem;
                    }

                    .image-overlay p {
                        font-size: 0.95rem;
                    }
                }

                @media (max-width: 480px) {
                    .login-left {
                        padding: 30px;
                        width:100%;

                    }

                      .login-container {
                      margin-top:85px
                      }

                    .login-title {
                        font-size: 1.6rem;
                    }

                    .form-footer {
                    
                        gap: 12px;
                    }
                }
            `}
                </style>
            </div>
        </>


    );
};

export default LoginPage;
